import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import constants from 'utils/constants';
import { ApiContext } from 'utils/networking/Api.context';

export default function usePoliceReportS3ConfigHook(type = 'PV') {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    fileFormat: null,
    filePrefix: null,
    fileSufix: null,
    s3DirPath: null,
    testFile: null,
    ftpFiles: [],
    ftpErrors: [],
    ftpResult: [],
    ftpfileValidationError: null,
    fileContent: null,
    isValidation: false,
    isFileList: false,
    dateSelected: null,
    extension: '.txt',
    sendStatusType: null,
  });

  useEffect(() => {
    const fetchConfig = async () => {
      await actions.loadPoliceReportConfig();
    };
    fetchConfig();
  }, [appState.selectedHotel]);

  const actions = {
    loadPoliceReportConfig: async () => {
      try {
        updateState({ isLoading: true });

        const res =
          type === 'PV'
            ? await API.getPoliceConfig({ hotelId: getSelectedHotel()?.key })
            : await API.getBookingReportConfig({ hotelId: getSelectedHotel()?.key });

        const file = res?.fileFormat || '';
        const extension = file ? file.substring(file.lastIndexOf('.')) : '.txt';
        const fileWithoutExtension = file ? file.substring(0, file.lastIndexOf(extension)) : '';
        const possibleFormats = ['YYYY-MM-DD', 'YYYYMMDD', 'DD-MM-YYYY', 'DDMMYYYY'];
        const detectedFormat =
          possibleFormats.find(fmt => fileWithoutExtension.includes(fmt)) || 'YYYY-MM-DD';
        const filePrefix = file.substring(0, file.indexOf(detectedFormat));
        const fileSufix = fileWithoutExtension.substring(
          fileWithoutExtension.indexOf(detectedFormat) + detectedFormat.length
        );

        updateState({
          isLoading: false,
          fileFormat: detectedFormat,
          filePrefix,
          fileSufix,
          s3DirPath: res?.s3DirPath,
          dateSelected: res?.dateSelected,
          extension,
          sendStatusType: res?.sendStatusType || null,
        });
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
      }
    },

    onCheckConnection: async () => {
      try {
        updateState({ isLoading: true });
        const body = { hotelId: getSelectedHotel()?.key, type: type };
        const res = await API.policeReportCheckS3Connection(body);

        updateState({
          isLoading: false,
          ftpFiles: res && res.length > 0 ? res : [],
          isValidation: false,
          isFileList: true,
        });

        notification.success({ message: translate('policeReport.checkConnectionSuccess') });
      } catch (err) {
        console.warn(err);
        updateState({
          isLoading: false,
          ftpFiles: [],
          ftpResult: [],
          isValidation: false,
          isFileList: true,
        });
        notification.error({ message: translate('policeReport.checkConnectionError') });
      }
    },

    onSaveFTPConfig: async () => {
      try {
        updateState({ isLoading: true });
        await API.updatePoliceSFTP({
          type: type,
          hotelId: getSelectedHotel()?.key,
          bookingProvider: constants.BOOKING_PROVIDER.S3,
          ftpConfig: {
            dateSelected: state.dateSelected,
            sendStatusType: state.sendStatusType || null,
          },
          fileFormat: state.fileFormat + state.extension,
          filePrefix: state.filePrefix,
          fileSufix: state.fileSufix,
        });

        await actions.onCheckConnection();
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
        notification.error({ message: translate('policeReport.ftpError') });
      }
    },

    validateFileExport: async () => {
      try {
        updateState({ isLoading: true, ftpfileValidationError: null });
        const res = await API.policeReportValidateFileExportS3({
          hotelId: getSelectedHotel()?.key,
          file: state.testFile,
        });

        const fileContent = res.fileContent || '';
        const errors = res.errors || [];
        const sortedValidations = [
          ...errors.filter(item => item.error === 'error'),
          ...errors.filter(item => item.error !== 'error'),
        ];

        updateState({
          isLoading: false,
          ftpErrors: sortedValidations,
          ftpResult: errors,
          fileContent,
          isValidation: true,
          isFileList: false,
        });

        notification.success({ message: translate('policeReport.validateFileExportSuccess') });
      } catch (err) {
        const errorMessage = err?.response?.data?.message;
        console.warn(err);
        updateState({
          isLoading: false,
          ftpErrors: [],
          ftpFiles: [],
          ftpResult: [],
          ftpfileValidationError: errorMessage,
          isValidation: false,
          isFileList: false,
        });
        notification.error({ message: translate('policeReport.validateFileExportError') });
      }
    },

    setField: (fieldKey, value) => updateState({ [fieldKey]: value }),

    isAdmin: () => !!appState?.superUser,
  };

  function updateState(obj) {
    setState(prev => ({ ...prev, ...obj }));
  }

  return { state, actions };
}
